import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { SketchPicker } from 'react-color';

const ListaTP = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista" id="miLista" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>PROPIEDADES FISICO</option>
        <option>PROPIEDADES QUIMICAS</option>
        <option>INFRA-ROJO (abs /  mm)</option>
        <option>CONTAMINACION</option>
        <option>DESGASTE DE METALES(ppm)</option>
        <option>CONTAMINANTES EXTERNOS, ppm (mg/kg)</option>  
        <option>ADITIVOS DEL ACEITE, ppm (mg/kg)</option>
        <option>Pruebas especiales</option>
      </select>
    </div>
  )
};

const ListaTV = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="miLista1" id="miLista1" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Rango de % en Aceite nuevo</option>
        <option>Mayor que % de referencia en Aceite nuevo</option>
        <option>Menor que % de referencia en Aceite nuevo</option>
        <option>Mayor que valor único de referencia</option>
        <option>Mayor que 3 valores de referencia</option>
        <option>No se compara</option>
        <option>Valores en sistema</option>
      </select>
    </div>
  )
};
// class AddPrueba2 extends React.Component {
const AddPrueba2 = ({styles, list, handleLista, handleLista1, handleSubmit, handleChange, 
                      args, errors}) => {

return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Prueba nueva
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui four column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Tipo de prueba</label>
                  <ListaTP styles={styles} handleLista={handleLista} />
                </Form.Field>                
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrPrueba" id="descrPrueba" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrPrueba'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Unidad</label>
                  <Form.Input autoComplete="off" name="unidad" id="unidad" onChange={handleChange} placeholder='Unidad' icon={!errors.length?null: _find(errors, {path:'unidad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>                    
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Tipo de validación</label>
                  <ListaTV styles={styles} handleLista={handleLista1} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Código de norma</label>
                  <Form.Input autoComplete="off" name="codNorma" id="codNorma" onChange={handleChange} placeholder='Código de norma' icon={!errors.length?null: _find(errors, {path:'codNorma'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Norma</label>
                  <Form.Input autoComplete="off" name="descrNorma" id="descrNorma" onChange={handleChange} placeholder='Norma' icon={!errors.length?null: _find(errors, {path:'descrNorma'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Campo en BD</label>
                  <Form.Input autoComplete="off" name="campoBD" id="campoBD" onChange={handleChange} placeholder='Campo en BD' icon={!errors.length?null: _find(errors, {path:'campoBD'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>                
              </div>
              <div className="column" style={{width: '25%'}}>
                <Form.Field>
                  <label style={styles.label}>Archivo</label>
                  <Form.Input autoComplete="off" name="descrArchivo" id="descrArchivo" onChange={handleChange} placeholder='Archivo' icon={!errors.length?null: _find(errors, {path:'descrArchivo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
              </div>
            </div>
          </div>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <label style={styles.label}>Análisis para confiable</label>
                <textarea name="analisisCon" id="analisisCon" cols="40" rows="3" onChange={handleChange}></textarea>                
                <label style={styles.label}>Análisis para precaución</label>
                <textarea name="analisisPre" id="analisisPre" cols="40" rows="3" onChange={handleChange}></textarea>                
                <label style={styles.label}>Análisis para alarma</label>
                <textarea name="analisisAla" id="analisisAla" cols="40" rows="3" onChange={handleChange}></textarea>                
                <label style={styles.label}>Análisis para peligro</label>
                <textarea name="analisisPel" id="analisisPel" cols="40" rows="3" onChange={handleChange}></textarea>                
                <label style={styles.label}>Recomendaciones para confiable</label>
                <textarea name="recomenCon" id="recomenCon" cols="40" rows="3" onChange={handleChange}></textarea>                
                <label style={styles.label}>Recomendaciones para precaución</label>
                <textarea name="recomenPre" id="recomenPre" cols="40" rows="3" onChange={handleChange}></textarea>                
                <label style={styles.label}>Recomendaciones para alarma</label>
                <textarea name="recomenAla" id="recomenAla" cols="40" rows="3" onChange={handleChange}></textarea>                
                <label style={styles.label}>Recomendaciones para peligro</label>
                <textarea name="recomenPel" id="recomenPel" cols="40" rows="3" onChange={handleChange}></textarea>                
              </div>
              <Button style={styles.confirmar} type='submit' fluid>
                AGREGAR 
              </Button>

              {
                errors.length?<Message negative header="Los siguientes errores:"
                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
              }
            </div>
          </div>
        </Form>
      </div>
    </div>
  )

}

export default AddPrueba2
